import { render } from "./indexfivetestimonial.vue?vue&type=template&id=225c772c"
import script from "./indexfivetestimonial.vue?vue&type=script&lang=js"
export * from "./indexfivetestimonial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__